import React, { Suspense, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { connect, useDispatch } from "react-redux";
import {
  createProfileMiddleware,
  getZodiacByIDMiddleware,
  listZodiacMiddleware,
} from "../compactibility/store/compactibilityMiddleware";
import { setLoader } from "../../redux/store/commonReducer";
import {
  formatZodiacSigns,
  getDateWithOffset,
  getMonthName,
  scrollTop,
  toLowerCaseKeys,
} from "../../utils/util";
import { getHoroscopeSignMiddleWare } from "./store/horoscopeMiddleware";
import { DATE_FORMAT } from "../../utils/constant";
import Footer from "../../components/footer/footer";
import { getValue } from "../consult-astrology/ConsultAstrologyScreen";
import { getCityMiddleWare } from "../Prompt/store/promptMiddleware";
import "./horoscope.scss";
import Loader from "../../packages/Loader/Loader";
import { _astroContentKey, _date } from "./mock";

const HoroscopeHeader = React.lazy(() => import("./HoroscopeHeader"));
const ZodiacSigns = React.lazy(() => import("./ZodiacSigns"));
const HoroscopeSection = React.lazy(() => import("./HoroscopeSection"));
const FormComponent = React.lazy(() => import("./FormComponent"));
const KidsSection = React.lazy(() => import("../home/KidsSection"));
const FriendSection = React.lazy(() => import("./FriendSection"));
const TopBar = React.lazy(() => import("../../components/topbar/topbar"));
const SubMenu = React.lazy(() => import("../../components/sub-menu/sub-menu"));

dayjs.extend(customParseFormat);

function mapStateToProps({
  compactibilityReducers,
  horoscopeReducers,
  cityReducers,
}) {
  return {
    zodiacList: compactibilityReducers?.zoiacList?.data
      ? formatZodiacSigns(compactibilityReducers?.zoiacList?.data)
      : [],
    horoscopeDetails:
      horoscopeReducers.data?.data?.zodiacResponse?.response || [],
    locationList: cityReducers.data,
  };
}

export const SlickButtonFix = ({
  currentSlide,
  slideCount,
  children,
  ...props
}) => <span {...props}>{children}</span>;

export const convertIsActiveToString = (arr) => {
  return arr?.map((obj) => {
    return {
      ...obj,
      isactive: obj.isactive?.toString(),
      state: {
        ...obj.state,
        isactive: obj.state?.isactive?.toString(),
      },
    };
  });
};

const HoroscopeScreen = ({ zodiacList, horoscopeDetails, locationList }) => {
  const [selectZodiac, setSelectZodiac] = useState(0);
  const [selectZodiacItem, setSelectZodiacItem] = useState(null);
  const [astroDate, setAstroDate] = useState(0);
  const [astroContent, setAstroContent] = useState(0);
  const [friendScreen, setFriendScreen] = useState(false);
  const isDispatched = useRef(false);
  const [formValue, setFormValue] = useState({
    name: "",
    dob: "",
    tob: "",
    location: "",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDetails = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const newDataLocationList = convertIsActiveToString(
    toLowerCaseKeys(locationList)
  );

  useEffect(() => {
    if (!isDispatched.current) {
      if (localStorage.getItem("isLoggedIn")) {
        getZodiacUserApi();
      } else {
        getZodiacListApi();
      }
      getLocationList();
      isDispatched.current = true;
    }
  }, []);

  const _L = (action) => {
    return action
      .then(() => dispatch(setLoader(true)))
      .finally(() => dispatch(setLoader(false)));
  };

  const getLocationList = () => {
    _L(dispatch(getCityMiddleWare()));
  };

  const getHoroscopeDetails = (offset, queueId) => {
    const payload = {
      zodiacId: queueId ? queueId : selectZodiacItem?.queueId,
      zodiacDate: dayjs().add(offset, "days").format(DATE_FORMAT),
    };
    dispatch(setLoader(true));
    dispatch(getHoroscopeSignMiddleWare(payload))
      .then((res) => setAstroDate(offset))
      .finally(() => dispatch(setLoader(false)));
  };

  const getZodiacUserApi = () => {
    dispatch(setLoader(true));
    dispatch(listZodiacMiddleware());
    dispatch(getZodiacByIDMiddleware(userDetails?.data?.zodiacId))
      .then((res) => {
        if (res.payload.status_code === 200) {
          const data = res.payload.data;
          const startMonthName = getMonthName(data.monthStart);
          const endMonthName = getMonthName(data.monthEnd);
          const label = `${data.dataName} ${startMonthName} ${data.dateStart} – ${endMonthName} ${data.dateEnd}`;
          const dateRange = `${startMonthName} ${data.dateStart} – ${endMonthName} ${data.dateEnd}`;
          const item = {
            ...data,
            key: data._id,
            label: label,
            value: data.dataName,
            dateRange: dateRange,
          };
          setSelectZodiac(data?._id);
          setSelectZodiacItem(item);
          getHoroscopeDetails(astroDate, item?.queueId);
          console.log(item, "item");
        }
      })
      .finally(() => dispatch(setLoader(false)));
  };

  const getZodiacListApi = () => {
    dispatch(listZodiacMiddleware())
      .then((res) => {
        if (res.payload.status_code === 200) {
          const item = formatZodiacSigns(res.payload.data)[0];
          setSelectZodiacItem(item);
          setSelectZodiac(item?._id);
          getHoroscopeDetails(astroDate, item?.queueId);
        }
      })
      .finally(() => dispatch(setLoader(false)));
  };

  const handleCheckHoroscope = () => {
    dispatch(setLoader(true));
    dispatch(createProfileMiddleware(formValue))
      .then((res) => {
        if (res.payload.status_code === 200) {
          const queueId = res.payload?.data?.[0]?.queueId;
          setAstroContent(0);
          setFriendScreen(true);
          getHoroscopeDetails(0, queueId);
        }
      })
      .finally(() => dispatch(setLoader(false)));
    scrollTop();
  };

  const setLoginModalVisible = () => {
    toast.info("Please Login to buy kids kundli", {
      position: "top-center",
    });
  };
  return (
    <Suspense fallback={<Loader />}>
      <div className="topDivNoStar">
        <TopBar />
        <div className="horoscope-container">
          <SubMenu />
          {!friendScreen && (
            <>
              <HoroscopeHeader />
              <ZodiacSigns
                setSelectZodiac={setSelectZodiac}
                setSelectZodiacItem={setSelectZodiacItem}
                getHoroscopeDetails={getHoroscopeDetails}
                zodiacList={zodiacList}
                selectZodiac={selectZodiac}
                SlickButtonFix={SlickButtonFix}
                astroDate={astroDate}
              />
              <HoroscopeSection
                selectZodiacItem={selectZodiacItem}
                _date={_date}
                astroDate={astroDate}
                getHoroscopeDetails={getHoroscopeDetails}
                getDateWithOffset={getDateWithOffset}
                horoscopeDetails={horoscopeDetails}
                setAstroContent={setAstroContent}
                astroContent={astroContent}
                _astroContentKey={_astroContentKey}
              />
              <FormComponent
                newDataLocationList={newDataLocationList}
                formValue={formValue}
                setFormValue={setFormValue}
                getValue={getValue}
                handleCheckHoroscope={handleCheckHoroscope}
              />
              <KidsSection
                navigate={navigate}
                setLoginModalVisible={setLoginModalVisible}
                buttonName="Buy Now"
              />
            </>
          )}
          {friendScreen && (
            <FriendSection
              setAstroContent={setAstroContent}
              horoscopeDetails={horoscopeDetails}
              astroContent={astroContent}
              _astroContentKey={_astroContentKey}
            />
          )}
        </div>
        <Footer />
      </div>
    </Suspense>
  );
};

export default connect(mapStateToProps)(HoroscopeScreen);
